module.exports = __webpack_public_path__ + "img/banner2.dfd2060d.jpg";